

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard React base styles
import colors from "assets/theme/base/colors";

function BusinessEnquiry({ color, size }) {
    return (
        <svg
            width={size}
            height={size}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512">
            <g data-name="<Group>">
                <path d="M493,133a48,48,0,0,0-48-48H67a48,48,0,0,0-48,48V380a48,48,0,0,0,48,48H445a48,48,0,0,0,48-48ZM67.006,101H444.994A31.789,31.789,0,0,1,477,132.7v5.464L283.814,289.792a41.973,41.973,0,0,1-51.7-.033L35,138.138V132.7A31.789,31.789,0,0,1,67.006,101ZM353.068,255.777,477,158.507V376.079Zm-190.55.636L35,376.383V158.324ZM444.994,411H67.006a31.9,31.9,0,0,1-28.068-16.5L175.37,266.22l46.949,36.152a57.921,57.921,0,0,0,71.351.012l46.691-36.642L473.1,394.442A31.9,31.9,0,0,1,444.994,411Z" data-name="<Compound Path>"></path><path d="M227,167.389a28.82,28.82,0,1,1,37.908,27.267A24.639,24.639,0,0,0,248,218.213V241h16V218.213a8.694,8.694,0,0,1,5.9-8.35A44.659,44.659,0,1,0,211,167.389V175h16Z" data-name="<Path>"></path>
                <rect width="16" height="22" x="248" y="247" data-name="<Path>"></rect>
            </g>
        </svg>
    );
}

// Setting default values for the props of BusinessEnquiry
BusinessEnquiry.defaultProps = {
    color: "dark",
    size: "16px",
};

// Typechecking props for the BusinessEnquiry
BusinessEnquiry.propTypes = {
    color: PropTypes.oneOf([
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "error",
        "dark",
        "light",
        "white",
    ]),
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default BusinessEnquiry;
